export const getProductUrl = (brandLink, handleParameter) => {
    return `${brandLink}${
        handleParameter && handleParameter.length && brandLink.length ? `/products/${handleParameter}` : ''
    }`;
};
